export function cacheLast() {
    let lastArgs = [];
    let lastFn;
    let lastThis;

    const isArgEqualToLast = (newArg: any, index: number) => newArg === lastArgs[index];

    return function(fn, ...args) {
        if (lastFn
            && lastThis === this
            && lastArgs.length === args.length
            && args.every(isArgEqualToLast)) {
            return lastFn;
        }

        lastThis = this;
        lastArgs = args;
        lastFn = fn;
        return lastFn;
    };
}
